export const useCustomFormErrors = () => {
  const customError = ref({});

  function setCustomError(formErrors: any, errorWrapperClass: string = '.customError__Wrapper', fieldErrorsKey: string = 'field_errors') {
    if (!formErrors) return;
    if (formErrors[fieldErrorsKey]) {
      const fieldErrors = formErrors[fieldErrorsKey];
      for (let error in fieldErrors) {
        fieldErrors[error] = { code: fieldErrors[error] }
      }
    }

    if (formErrors.error_code || formErrors.details?.code) {
      const element = document.querySelector(errorWrapperClass);
      customError.value = { code: formErrors.error_code || formErrors.details?.code };
      if (element) element.scrollIntoView({ behavior: 'smooth' })
      else window.scrollTo(0, 0);
    } else {
      customError.value = {};
    }
  }

  return {
    customError,
    setCustomError,
  }
}